import React from "react";
import Card from "../Cards/Card";
import "./CardList.css";

const CardList = (props) => {
  // console.log("assets en cardlist", props.assets);
  const sendToGoogle=(asset)=>
  {
   //datalayer for gtm code
   window.dataLayer.push({event:"Obra",titulo:asset.title.replace(/<[^>]*>/g, '')});
  }
  return (
    <ul className="home__cards">
      {props.assets.map((asset) => {
        return (
         asset.showEvent && <>  <li tabindex="0" className="home__cards__item" key={asset.assetId} onClick={()=>sendToGoogle(asset)}>
            <Card lang={props.lang} info={asset} />
          </li>
          </>
        
        );
      })}
    </ul>
  );
};

export default CardList;
